"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Imagecarousel = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
const _ = __importStar(require("lodash"));
const js_cookie_1 = __importDefault(require("js-cookie"));
const plyr_1 = __importDefault(require("plyr"));
class Imagecarousel {
    constructor(element) {
        // elements
        this.element = null;
        this.big_image = null;
        this.big_image_credits = null;
        this.active_thumbnail = null;
        this.active_thumbnail_index = 0;
        this.images = [];
        this.images_count = 0;
        this.skipper = null;
        this.fullscreen_image = null;
        this.scroll_X = 0;
        this.video = null;
        this.video_player = null;
        this.video_container = null;
        this.video_url = null;
        this.video_provider = null;
        this.video_accepted = false;
        this.video_consent = null;
        this.video_icon = null;
        this.element = element;
        this.big_image = (0, cash_dom_1.default)('img.bigimage', element);
        if (!this.big_image) {
            return;
        }
        this.images = (0, cash_dom_1.default)('.thumbnails > .thumbnail', element);
        if (!this.images || this.images.length <= 1) {
            return;
        }
        this.images_count = this.images.length;
        this.big_image.css({ cursor: 'zoom-in' });
        this.active_thumbnail = (0, cash_dom_1.default)(this.images[0]);
        this.active_thumbnail.addClass('active');
        this._initVideo();
        //this._addSkipAction();
        this._addThumbnailAction();
        this._addGalleryIndicatorAction();
        this._initFullscreenImage();
    }
    _initVideo() {
        var _a, _b, _c;
        // check for video element at last place
        if (!((_b = (_a = this.images) === null || _a === void 0 ? void 0 : _a.last()) === null || _b === void 0 ? void 0 : _b.hasClass('video'))) {
            return;
        }
        this.video = (_c = this.images) === null || _c === void 0 ? void 0 : _c.last();
        this.video_provider = this.video.attr('data-video-provider');
        this.video_url = this.video.attr('data-video-url');
        this.video_accepted = js_cookie_1.default.get(`external-${this.video_provider}`) ? true : false;
        this.video_consent = (0, cash_dom_1.default)('.video-consent', this.element);
        this.video_icon = (0, cash_dom_1.default)('.video-icon', this.element);
        this.video_icon.css('display', 'none');
        this.video_icon.on('click', () => {
            this._onChangeBigImage(this.images.length - 1);
            this._updateFullscreenIndicator();
            this._changeFullscreenImage();
            this.fullscreen_image.show();
        });
        // init video
        if (!this.video_accepted) {
            this.video_consent.hide();
            (0, cash_dom_1.default)('.accept', this.video_consent).on('click', () => {
                this.video_accepted = true;
                js_cookie_1.default.set(`external-${this.video_provider}`, new Date().toJSON(), { expires: 120 });
                this.video_consent.hide();
                this._changeFullscreenImage();
                setTimeout(() => {
                    this.video_player = new plyr_1.default('#fullscreenvideo');
                    this.video_container.show();
                    this.video_container.css('display', 'block');
                }, 100);
            });
        }
        else {
            this.video_player = new plyr_1.default('#fullscreenvideo');
        }
    }
    _addSkipAction() {
        const skipper = (0, cash_dom_1.default)('.imageNext', this.element);
        if (!skipper) {
            return;
        }
        skipper.show();
        skipper.on('click', (event) => {
            let new_index = this.active_thumbnail_index + 1 >= this.images_count ? 0 : this.active_thumbnail_index + 1;
            this._onChangeBigImage(new_index);
        });
    }
    _addThumbnailAction() {
        this.images.each((thumbnail_index) => {
            let thumbnail = (0, cash_dom_1.default)(this.images[thumbnail_index]);
            thumbnail.on('click', (event) => {
                this._onChangeBigImage(thumbnail_index);
            });
        });
    }
    _addGalleryIndicatorAction() {
        const indicators = (0, cash_dom_1.default)('.gallery-indicator .indicator', this.element);
        indicators.each((thumbnail_index) => {
            let indicator = (0, cash_dom_1.default)(indicators[thumbnail_index]);
            indicator.on('click', (event) => {
                this._onChangeBigImage(thumbnail_index);
            });
        });
    }
    _updateGalleryIndicator() {
        const indicators = (0, cash_dom_1.default)('.gallery-indicator .indicator', this.element);
        if (!indicators || indicators.length <= 1) {
            return;
        }
        indicators.each(indicator_index => {
            if (indicator_index == this.active_thumbnail_index) {
                (0, cash_dom_1.default)(indicators[indicator_index]).addClass('active');
            }
            else {
                (0, cash_dom_1.default)(indicators[indicator_index]).removeClass('active');
            }
        });
    }
    _onChangeBigImage(image_index) {
        var _a, _b, _c;
        let thumbnail = (0, cash_dom_1.default)(this.images[image_index]);
        this.active_thumbnail_index = image_index;
        this.images.removeClass('active');
        thumbnail.addClass('active');
        this._updateGalleryIndicator();
        if (thumbnail.hasClass('video')) {
            this.video_icon.css('display', 'block');
            this.big_image.addClass('video');
            this.big_image.attr('src', (0, cash_dom_1.default)('img', thumbnail).attr('data-preview'));
            this.video_icon.show();
        }
        else {
            (_a = this.video_icon) === null || _a === void 0 ? void 0 : _a.hide();
            (_b = this.video_consent) === null || _b === void 0 ? void 0 : _b.hide();
            this.big_image.removeClass('video');
            const thumbnail_path = (0, cash_dom_1.default)('img', thumbnail).attr('src');
            this.big_image_credits = (_c = (0, cash_dom_1.default)(thumbnail).attr('rel')) !== null && _c !== void 0 ? _c : '';
            this.big_image.attr('src', this._getBigImageUrl(thumbnail_path, '1226x684'));
        }
    }
    _getBigImageUrl(thumbnail_path, new_format = 'original') {
        //const thumbnail_path = $('img', thumbnail).attr('src');
        if (!thumbnail_path || thumbnail_path.length < 3) {
            return;
        }
        const regex = new RegExp('([^\\/]+)([\\.]\\w{3,4}$)', 'ms');
        const replace = `${new_format}\$2`; //1226x684
        const big_image_path = thumbnail_path.replace(regex, replace);
        return big_image_path;
    }
    _initFullscreenImage() {
        this.fullscreen_image = (0, cash_dom_1.default)('.fullscreen-image', this.element);
        if (!this.fullscreen_image) {
            return;
        }
        this.video_container = (0, cash_dom_1.default)('.video_player', this.fullscreen_image);
        this.video_container.hide();
        this.big_image.on('click touch', (event) => {
            console.log("click", event);
            this._updateFullscreenIndicator();
            this._changeFullscreenImage();
            this.fullscreen_image.show();
        });
        (0, cash_dom_1.default)('.top svg', this.fullscreen_image).on('click touch', () => {
            var _a;
            (_a = this.video_player) === null || _a === void 0 ? void 0 : _a.pause();
            this.fullscreen_image.hide();
        });
        (0, cash_dom_1.default)('.prev', this.fullscreen_image).on('click touch', () => {
            var _a;
            let new_index = this.active_thumbnail_index - 1 < 0 ? this.images_count - 1 : this.active_thumbnail_index - 1;
            this._onChangeBigImage(new_index);
            this._updateFullscreenIndicator();
            this._changeFullscreenImage();
            (_a = this.video_player) === null || _a === void 0 ? void 0 : _a.pause();
        });
        (0, cash_dom_1.default)('.next', this.fullscreen_image).on('click touch', () => {
            var _a;
            let new_index = this.active_thumbnail_index + 1 >= this.images_count ? 0 : this.active_thumbnail_index + 1;
            this._onChangeBigImage(new_index);
            this._updateFullscreenIndicator();
            this._changeFullscreenImage();
            (_a = this.video_player) === null || _a === void 0 ? void 0 : _a.pause();
        });
        this.fullscreen_image.on('click touch', (e) => {
            const class_name = (0, cash_dom_1.default)(e.target).attr('class');
            if (_.indexOf(['backdrop', 'top', 'center', 'bottom'], class_name) >= 0) {
                this.fullscreen_image.hide();
            }
        });
        this.big_image.on('touchstart touchmove', (event) => {
            var _a, _b;
            if (event.type == "touchstart") {
                this.scroll_X = (event.touches || event.originalEvent.touches)[0].clientX;
            }
            else if (event.type == "touchmove") {
                const scrollDiff = this.scroll_X - event.touches[0].clientX;
                if (Math.abs(scrollDiff) < (0, cash_dom_1.default)(window).width() / 2) {
                    return;
                }
                this.scroll_X = event.touches[0].clientX;
                if (scrollDiff > 0) {
                    let new_index = this.active_thumbnail_index + 1 >= this.images_count ? 0 : this.active_thumbnail_index + 1;
                    this._onChangeBigImage(new_index);
                    this._updateFullscreenIndicator();
                    this._changeFullscreenImage();
                    (_a = this.video_player) === null || _a === void 0 ? void 0 : _a.pause();
                }
                else {
                    let new_index = this.active_thumbnail_index - 1 < 0 ? this.images_count - 1 : this.active_thumbnail_index - 1;
                    this._onChangeBigImage(new_index);
                    this._updateFullscreenIndicator();
                    this._changeFullscreenImage();
                    (_b = this.video_player) === null || _b === void 0 ? void 0 : _b.pause();
                }
            }
        });
        this._addFullscreenIndicatorAction();
    }
    _changeFullscreenImage() {
        var _a;
        if ((0, cash_dom_1.default)(this.big_image).hasClass('video')) {
            (0, cash_dom_1.default)('figure', this.fullscreen_image).hide();
            if (this.video_accepted) {
                this.video_consent.hide();
                this.video_container.show();
            }
            else {
                this.video_container.hide();
                this.video_consent.show();
            }
            return;
        }
        this.video_container.hide();
        (0, cash_dom_1.default)('figure', this.fullscreen_image).show();
        (0, cash_dom_1.default)('figure img', this.fullscreen_image).addClass('loading');
        const big_image_src = (0, cash_dom_1.default)(this.big_image).attr('src');
        const fullscreen_src = (_a = this._getBigImageUrl(big_image_src, 'gallery-fullscreen')) !== null && _a !== void 0 ? _a : '';
        let img = new Image();
        img.src = fullscreen_src;
        img.onload = () => {
            (0, cash_dom_1.default)('figure img', this.fullscreen_image).attr('src', fullscreen_src);
            (0, cash_dom_1.default)('figure img', this.fullscreen_image).removeClass('loading');
            (0, cash_dom_1.default)('figure figcaption', this.fullscreen_image).html(this.big_image_credits);
        };
    }
    _updateFullscreenIndicator() {
        const indicators = (0, cash_dom_1.default)('.bottom .indicator', this.fullscreen_image);
        if (!indicators || indicators.length <= 1) {
            return;
        }
        indicators.each(indicator_index => {
            if (indicator_index == this.active_thumbnail_index) {
                (0, cash_dom_1.default)(indicators[indicator_index]).addClass('active');
            }
            else {
                (0, cash_dom_1.default)(indicators[indicator_index]).removeClass('active');
            }
        });
    }
    _addFullscreenIndicatorAction() {
        const indicators = (0, cash_dom_1.default)('.bottom .indicator', this.fullscreen_image);
        if (!indicators || indicators.length <= 1) {
            return;
        }
        indicators.each((indicator_index) => {
            let indicator = (0, cash_dom_1.default)(indicators[indicator_index]);
            indicator.on('click', (event) => {
                this._onChangeBigImage(indicator_index);
                this._updateFullscreenIndicator();
                this._changeFullscreenImage();
            });
        });
    }
    _checkVideoConsent(provider) {
        return false;
    }
}
exports.Imagecarousel = Imagecarousel;
